// 'use strict';
// angular.module('levelsBeyond.ui.progress', [
//     'levelsBeyond.ui.progress.templates'
// ]).directive('lbProgress', function lbProgressFactory(){
//
//     return {
//         scope: {
//             lbProgress: '='
//         },
//         templateUrl: 'progress.tpl.html',
//         restrict: 'A',
//         link: function ($scope, $iElement/*, $iAttrs, Controller*/) {
//
//             var defaults = {
//                 backdrop: true,
//                 title: 'Loading',
//                 message: '',
//                 size: 'lg'
//             };
//
//             angular.extend(defaults, $scope.lbProgress);
//
//             // Show backdrop.
//             if (defaults.backdrop) {
//                 $iElement.addClass('preloader-backdrop');
//             }
//
//             // Expose the settings to the template.
//             $scope.lbProgress = defaults;
//
//             return;
//
//         }
//
//     };
//
// });


'use strict';

angular.module('prism-ui.components')
    .directive('lbProgress', function lbProgressFactory(){

    return {
        scope: {
            lbProgress: '='
        },
        templateUrl: 'components/visual/pacifier/pacifier-template.html',
        restrict: 'A',
        link: function ($scope, $iElement/*, $iAttrs, Controller*/) {

            var defaults = {
                backdrop: true,
                title: 'Loading',
                message: '',
                size: 'lg'
            };

            angular.extend(defaults, $scope.lbProgress);

            // Show backdrop.
            if (defaults.backdrop) {
                $iElement.addClass('preloader-backdrop');
            }

            // Expose the settings to the template.
            $scope.lbProgress = defaults;
        }

    };

});
